import Debug from 'debug';
import { customElement, property } from 'lit/decorators.js';
import { LitElement, nothing, PropertyValues } from 'lit';
import { dataBroker } from '../services/DataBroker';
import { PqdSqlClient } from './pdq-sqlite-client';
import { sqliteBroker } from '../services/SqliteBroker';

const log = Debug('pdq:sqlite:import');
@customElement('pdq-sqlite-import')
export class PdqSqliteImport extends LitElement  {

  @property({type: String}) database: string | undefined
  @property({type: String, attribute: "blob-name"}) blobName : string | undefined
  @property({type: Boolean }) overwrite = true

  cleanup = () => {}
  render = () => nothing

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    this.refresh().catch(e => log(`failed to refresh - ${e}`))
  }
  protected updated(_changedProperties: PropertyValues) {
    super.updated(_changedProperties);
    this.refresh().catch(e => log(`failed to refresh - ${e}`))
  }
  disconnectedCallback () {
    this.cleanup()
  }

  cacheKey = ''
  async refresh(){
    if (!this.blobName) {
      log(`refresh failed... no blobName`)
      return
    }
    if (!this.database) {
      log(`refresh failed... no database path / name`)
      return
    }
    const ck = `${this.blobName}##${this.database}`
    if (this.cacheKey == ck)
      return
    this.cacheKey = ck
    log(`subscribing to blob[${this.blobName}]`)

    const blob$ = await dataBroker.getObservableDataSource(this.blobName)
    const sub = blob$.subscribe(async blob => {
      log(`blob[${this.blobName}] received...`)
      if (blob instanceof Blob) {

        const c = await sqliteBroker.getDatabaseClient(this.database!)
        await c.import(this.database!, blob, this.overwrite);
        await c.open(this.database!)
        const d = await c.query('SELECT * FROM sqlite_master')
        sqliteBroker.setDatabaseReady(this.database!)
      } else {
        log(`refresh failed... no blob found for ${this.blobName} - found type ${typeof blob}`)
      }
    })
    this.cleanup = () => sub.unsubscribe()
  }
}

